import { createAction, props } from '@ngrx/store';
import { DigitalPayeeEnrollmentStatus } from '../../models/digital-payee-enrollment-status.model';
import { DigitalPayeeEnrollment } from '../../models/digital-payee-enrollment.model';
import { NpoSearchResults } from '../../models/npo-search-results.model';
import { Npo } from '../../models/npo.model';

//// UI actions

export const returnedFromStripe = createAction(
    '[DppEnrollment] RETURNED_FROM_STRIPE',
    props<{ digitalPayeeId: number }>()
);

export const npoSearchModalOpened = createAction('[DppEnrollment] NPO_SEARCH_MODAL_OPENED');

export const npoSearched = createAction('[DppEnrollment] NPO_SEARCHED', props<{ ein: string }>());

export const pageChanged = createAction(
    '[DppEnrollment] PAGE_CHANGED',
    props<{ pageNumber: number }>()
);

export const npoSelected = createAction('[DppEnrollment] NPO_SELECTED', props<{ npo: Npo }>());

export const reviewSectionClosed = createAction('[DppEnrollment] REVIEW_SECTION_CLOSED');

export const partnershipChanged = createAction(
    '[DppEnrollment] PARTNERSHIP_CHANGED',
    props<{ isPartnership: boolean }>()
);

export const continuedToStripe = createAction('[DppEnrollment] CONTINUED_TO_STRIPE');

export const enrollmentSubmitted = createAction('[DppEnrollment] ENROLLMENT_SUBMITTED');

export const showErrorsIfClean = createAction('[DppEnrollment] SHOW_ERRORS_IF_CLEAN');

export const successPageExited = createAction('[DppEnrollment] SUCCESS_PAGE_EXITED');

//// API actions

// NPO search

export const postNpoSearch = createAction('[DppEnrollment API] POST_NPO_SEARCH');

export const npoSearchSuccess = createAction(
    '[DppEnrollment API] NPO_SEARCH_SUCCESS',
    props<{ npoSearchResults: NpoSearchResults }>()
);

export const npoSearchError = createAction('[DppEnrollment API] NPO_SEARCH_ERROR');

// Enrollment status

export const getEnrollmentStatus = createAction('[DppEnrollment API] GET_ENROLLMENT_STATUS');

export const enrollmentStatusSuccess = createAction(
    '[DppEnrollment API] ENROLLMENT_STATUS_SUCCESS',
    props<{ enrollmentStatus: DigitalPayeeEnrollmentStatus }>()
);

export const enrollmentStatusNotFound = createAction(
    '[DppEnrollment API] ENROLLMENT_STATUS_NOT_FOUND'
);

export const enrollmentStatusError = createAction('[DppEnrollment API] ENROLLMENT_STATUS_ERROR');

// Enroll

export const enroll = createAction(
    '[DppEnrollment API] ENROLL',
    props<{ enrollment: DigitalPayeeEnrollment }>()
);

export const enrollSuccess = createAction(
    '[DppEnrollment API] ENROLL_SUCCESS',
    props<{ enrollment: DigitalPayeeEnrollment }>()
);

export const enrollError = createAction('[DppEnrollment API] ENROLL_ERROR');

// Activate

export const activate = createAction(
    '[DppEnrollment API] ACTIVATE',
    props<{ digitalPayeeId: number; hasPartnership: boolean }>()
);

export const activateSuccess = createAction(
    '[DppEnrollment API] ACTIVATE_SUCCESS',
    props<{ enrollmentStatus: DigitalPayeeEnrollmentStatus }>()
);

export const activateError = createAction('[DppEnrollment API] ACTIVATE_ERROR');
